
    // **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "float",
        regionType:  "region_name_currency_symbol",
        floatingPosition: "bottom_right",
        floatingPaddingHorizontal:  10,
        floatingPaddingVertical:  10,
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "yes",
        selectorFlagMap: {'de': 'de', 'fr': 'fr'},
        displayType: "language_name",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",    
        defaultRegion: "CH",    
        primaryRegionById: {},    
        availableRegionsByCode: {},    
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Switzerland", "code": "CH", "currency": {"code": "CHF", "symbol": "SFr"}, "languages": {"Fran\u00e7ais": {"name": "Fran\u00e7ais (French)", "native_name": "Fran\u00e7ais", "code": "fr", "default": true}, "Deutsch": {"name": "Deutsch (German)", "native_name": "Deutsch", "code": "de", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
    